import { rem } from "../lib/utilities.js"

let triggerOrigin;
let trigger;
let triggerParent;
let header;
let hero;
let overlayVideo;
let trackingTimeout;

function updatePosition() {
   if (triggerOrigin && triggerParent) {
      const headerHeight = header ? header.offsetHeight : 0;
      triggerParent.style.left = `${triggerOrigin.offsetLeft}px`;
      triggerParent.style.top = `${triggerOrigin.offsetTop - triggerParent.offsetHeight / 2 + headerHeight}px`;
   }
}

window.addEventListener("DOMContentLoaded", () => {
   trigger = document.querySelector(".js-hero-overlay-trigger");
   hero = document.querySelector(".hero");
   header = document.querySelector(".header");

   if (trigger && hero) {
      triggerOrigin = document.querySelector(".js-hero-overlay-trigger-position");
      triggerParent = trigger.closest(".hero__overlay-trigger");
      overlayVideo = document.querySelector(".hero__overlay video");

      trigger.addEventListener("mouseenter", (event) => {
         hero.classList.add("has-visible-overlay");

         if (overlayVideo) {
            overlayVideo.play();

            if (trackingTimeout) {
               clearTimeout(trackingTimeout);
            }

            trackingTimeout = setTimeout(() => {
               if (typeof window["dataLayer"] !== "undefined") {
                  window["dataLayer"].push({ 'event': 'hover-project-loop' });
               }
            }, 1000);
         }
      });

      trigger.addEventListener("mouseleave", (event) => {
         hero.classList.remove("has-visible-overlay");

         if (overlayVideo) {
            overlayVideo.pause();
         }
      });
   }
});

window.addEventListener("load", () => updatePosition());
window.addEventListener("resize", () => updatePosition());
